import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EvidenceBar from "@/components/EvidenceBar";
import CapabilitiesBento from "@/components/CapabilitiesBento";
import ProblemBlock from "@/components/ProblemBlock";
import TheJourney from "@/components/TheJourney";
import ProductFrame from "@/components/ProductFrame";
import ResiliencePreview from "@/components/ResiliencePreview";
import TrustStrip from "@/components/TrustStrip";
import ContactCTA from "@/components/ContactCTA";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import DepthLayer from "@/components/DepthLayer";
import SEOHead from "@/components/SEOHead";

const Index=()=> <><SEOHead title="Skandor Technologies | We win when you win." description="A senior team that has shipped enterprise-grade products. We find where product, systems and operations stopped working as one, fix it with one accountable team, and stay until your people run it." canonicalPath="/"/><Navbar/><DepthLayer/><main id="main-content" tabIndex={-1} className="min-h-screen focus:outline-none"><Hero/><EvidenceBar/><CapabilitiesBento/><ProblemBlock/><TheJourney/><ProductFrame/><ResiliencePreview/><TrustStrip/><ContactCTA/><FAQ/></main><Footer/></>;
export default Index;